module.exports = __webpack_public_path__ + "img/collection-engagementRingsRingsets@2x.c2f149c.webp";